// extracted by mini-css-extract-plugin
export default {"title":"styles_title__UxH2W","subTitle":"styles_subTitle__ZTb+h","text":"styles_text__NuydA"};